const rewards = [
  [0, 0],
  [500, 150],
  [750, 225],
  [1000, 300],
  [1250, 450],
  [1500, 460],
  [1600, 470],
  [1700, 480],
  [1800, 490],
  [1900, 500],
  [2000, 510],
  [2000, 510],
  [2100, 520],
  [2200, 530],
  [2300, 540],
  [2400, 550],
  [2500, 560],
  [2600, 570],
  [2700, 580],
  [2800, 590],
  [2900, 600],
  [3000, 610],
  [3100, 620],
  [3200, 630],
  [3300, 640],
  [3400, 650],
  [3500, 660],
  [3600, 670],
  [3700, 680],
  [3800, 690],
  [3900, 700],
  [4000, 710],
  [4100, 720],
  [4200, 730],
  [4300, 740],
  [4400, 750],
  [4500, 760],
  [4600, 770],
  [4700, 780],
  [4800, 790],
  [4900, 800],
  [5000, 810],
  [5100, 820],
  [5200, 830],
  [5300, 840],
  [5400, 850],
  [5500, 860],
  [5600, 870],
  [5700, 880],
  [5800, 890],
  [5900, 900],
  [6000, 910],
  [6100, 920],
  [6200, 930],
  [6300, 940],
  [6400, 950],
  [6500, 960],
  [6600, 970],
];

export default rewards;
